<template>
	<div>
		<div class="event-layout">
			<events-header :container="false" />
			<nuxt />
			<modal name="event" />
		</div>
		<chat />
		<toaster />
	</div>
</template>

<script>
import EventsHeader from '~/components/EventsHeader'
import Toaster from '~/components/managers/Toaster'
import Modal from '~/components/managers/Modal'
import Chat from '~/components/interface/Chat'

export default {
	name: 'Event',
	components: { Modal, EventsHeader, Toaster, Chat }
}
</script>

<style lang="scss">
.event-layout {
  padding-top: calc(#{$headerHeight});
  min-height: 100vh;
  display: flex;
  flex-grow: 1;

  &::before {
    height: calc(100% - 44px);
  }

  @include respond-below(tablet) {
	  height: 100%;
  }
}

body .siq_bR {
  bottom: 50px;
}
body .zsiq_theme1 div.zsiq_cnt {
  display: none;
}
</style>
